import { Model } from '@danangelus/ngx-app-core';

export class Bulletin extends Model {
    id: string | undefined
    author: string | undefined
    emailAddress: string | undefined
    emailMessage: string | undefined
    excludeAttachments: boolean | undefined
    expiryDate: Date | undefined
    important: boolean | undefined
    publishDate: Date | undefined
    refNo: string | undefined
    rejectionNote: string | undefined
    rolesExcludedFromEmail: string | undefined
    sentDate: Date | undefined
    status: Status | undefined
    subject: string | undefined
    summarySentDate: Date | undefined
    campaignIds: string | undefined
    document: BulletinDocument | undefined
    attachments: AttachmentDocument[] = []
    emailDistributionList: string[] = []
    categories: Category[] = []
    products: Product[] = []
    emailGroups: EmailGroup[] = []
    franchises: string[] = []
    divisions: string[] = []
    roles: string[] = []
    approvers: string[] = []
    recipients: string[] = []
    countries: string[] = []
    readership: BulletinReadership[] = []
    lastModified: Date | undefined
    createdDate: Date | undefined

    constructor(bulletin?: any) {
        super(bulletin)
    }

    static fromDto(dto: BulletinDto): Bulletin {
        return new Bulletin({
            id: dto.id,
            subject: dto.subject,
            author: dto.author,
            refNo: dto.refNo,
            emailMessage: dto.emailMessage,
            publishDate: dto.publishDate
        });
    }
}

export class AttachmentDocument extends Model {
    id: string | undefined
    bulletin: Bulletin | undefined
    fileUuid: string | undefined
    mimeType: string | undefined
    filename: string | undefined
    lastModified: Date | undefined
    createdDate: Date | undefined
}

export class BulletinDocument extends Model {
    id: string | undefined
    sharepointSent: boolean | undefined
    fileUuid: string | undefined
    mimeType: string | undefined
    filename: string | undefined
    lastModified: Date | undefined
    createdDate: Date | undefined
}

export class BulletinDto extends Model {
    id = ''
    author = ''
    emailMessage = ''
    refNo = ''
    subject = ''
    publishDate: Date

    constructor(bulletin?: any) {
        super(bulletin)

        this.publishDate = bulletin.publishDate
    }
}

export class BulletinReadStatus extends Model {
    bulletin: BulletinDto | undefined
    readership: BulletinReadershipDto[] | undefined
    document: BulletinDocument | undefined
    attachments: AttachmentDocument[] | undefined
}

export class BulletinReadership extends Model {
    id: string | undefined
    bulletin: Bulletin | undefined
    userName: string | undefined
    dealer: string | undefined
    lastModified: Date | undefined
    createdDate: Date | undefined

    constructor(bulletinReadership?: any) {
        super(bulletinReadership);
    }
}

export class BulletinReadershipDto extends Model {
    id: string | undefined
    userName: string | undefined

    constructor(bulletinReadership?: any) {
        super(bulletinReadership);
    }
}

export class Category extends Model {
    id: string | undefined
    name: string | undefined
    lastModified: Date | undefined
    createdDate: Date | undefined
}

export class EmailGroup extends Model {
    id: string | undefined
    name: string | undefined
    active: boolean | undefined
    emailList: string | undefined
    lastModified: Date | undefined
    createdDate: Date | undefined
}

export class Product extends Model {
    id: string | undefined
    name: string | undefined
    division: string | undefined
    lastModified: Date | undefined
    createdDate: Date | undefined
}

export enum Status {
    DRAFT = 'DRAFT',
    AWAITING_APPROVAL = 'AWAITING_APPROVAL',
    WITH_APPROVER = 'WITH_APPROVER',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    PUBLISHED = 'PUBLISHED',
    EXPIRED = 'EXPIRED'
}
